import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShopLogoUrlPipe } from 'src/app/shared/pipes/shop-logo-url.pipe';
import { SharedModule } from 'src/app/shared/shared.module';
import { SplashScreenComponent } from './splash-screen.component';

@NgModule({
  declarations: [SplashScreenComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [SplashScreenComponent],
  providers: [ShopLogoUrlPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SplashScreenModule {}
